

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.CN2lhy59.js","_app/immutable/chunks/KZK0-soZ.js","_app/immutable/chunks/BZTNq1Um.js","_app/immutable/chunks/2mOfPPFS.js","_app/immutable/chunks/o-fdcMLv.js","_app/immutable/chunks/kwBiegc5.js"];
export const stylesheets = [];
export const fonts = [];
